import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FeatureHero } from '../../../../widgets/feature-hero/feature-hero';

@Component({
  selector: 'app-network-switch-management',
  imports: [RouterModule, FeatureHero],
  templateUrl: './network-switch-management.html',
  styleUrl: './network-switch-management.scss',
})
export class NetworkSwitchManagement {

}
